<script>
    import Article from "~/components/Article.svelte";
    import Spinner from '~/components/Spinner.svelte';
    import Editor from '~/components/Editor.svelte';

    import { navigate } from 'svelte-routing';
    import { db, isAdmin } from '~/firebase';
    import { slide } from 'svelte/transition';
    
    export let id;
    
    let post = null;
    let loading = false;
    let isEditing = false;
    let isDeleted = false;

    $: fetchPost(id, $isAdmin);

    async function fetchPost(postId) {
        loading = true;
        try {
            post = await db.ref(`/posts/${postId}`).get();
        }
        catch (e) {
            console.log(e);
        }
        loading = false;
    }

    function doneEditing(e) {
        isEditing = false;
        if (e.detail.deleted) {
            navigate('/');
            isDeleted = true; // For some reason this component gets stuck on
        }
        else {
            fetchPost(id);
        }
    }

</script>

<svelte:head>
    <title>Nan Dake{post ? ` - ${post.title}` : ''}</title>
</svelte:head>

{#if !isDeleted}
    {#if post}
        {#if $isAdmin}
            <div>
                {#if isEditing}
                    <Editor {post} on:cancel={() => isEditing = false} on:done={doneEditing} />
                {:else}
                    {#if !post.visible}
                        <div>[hidden]</div>
                    {/if}
                    <Article
                        title={post.title}
                        tags={post.tags}
                        date={post.timestamp}
                        contents={post.contents}
                        files={post.files}
                        showAll={true}
                        category={post.category}
                    />
                    <a href="javascript:void(0);" on:click={() => isEditing = true}>Edit post</a>
                {/if}
            </div>
        {:else}
            <Article
                title={post.title}
                tags={post.tags}
                date={post.timestamp}
                contents={post.contents}
                files={post.files}
                showAll={true}
                category={post.category}
            />
        {/if}
    {:else if !loading}
        <div transition:slide={{ duration: 200 }}>The post couldn't be found. Maybe try another page?</div>
    {/if}

    {#if loading}
        <Spinner/>
    {/if}
{/if}